import React, { useState, Fragment } from 'react';
import { Row, Input, Label, Button, FormGroup } from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Domains } from '../../../../../../../constants/APIs';
import Validation from '../../../../../../../components/Validation';
export default function DomainsForm({ domains, id }) {
  const [inputFields, setInputFields] = useState(domains);
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: 'AccommodationProviders',
      priority: 1,
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'priority') {
      values[index].priority = event.target.value;
    } else {
      values[index].type = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { domains: [...inputFields], updater: 'admin' };
    //console.log(data);
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Domains}/${id}`,
      data,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    }
    );
  };

  return (
    <div>
      <h4>Domains</h4>
      {/* <pre>{JSON.stringify(inputFields, null, 2)}</pre> */}
      <Row>
        {inputFields.map((domain, index) => (
          <Fragment key={index}>
            <Colxx sm={4} className="md-3">
              <Label>Type</Label>
              <Input className='input_sty'
                type="select"
                value={domain.type}
                name="type"
                onChange={(event) => handleInputChange(index, event)}
              >
                <option value="AccommodationProviders">
                  Accommodation Providers
                </option>
                <option value="Lawnmowers">Lawnmowers</option>
                <option value="Electricians">Electricians</option>
                <option value="Coaching">Coaching</option>
                <option value="Retail">Retail</option>
                <option value="Covid">Covid</option>
                <option value="Smalltalk">Smalltalk</option>
                <option value="RetirementHomes">Retirement Homes</option>
                <option value="Salons">Salons</option>
                <option value="SalonsSmallTalk">Salons SmallTalk</option>
                <option value="HolidaysPark">Holidays Park</option>
                <option value="QuarantineBot">Quarantine Bot</option>
                <option value="HolidayHomes">Holiday Homes</option>
                <option value="VirtualVetNurse">Virtual Vet Nurse</option>
                <option value="Tourism">Tourism</option>
                <option value="Doctors">Doctors</option>
                <option value="Northable">Northable</option>
                <option value="Golf">Golf</option>
                <option value="BusinessOperator">Business Operator</option>
                <option value="VoucherEngine">VoucherEngine</option>
                <option value="Activities">Activities</option>
                <option value="Restaurant">Restaurant</option>
                <option value="UtilityProviders">Utility Providers</option>
              </Input>
            </Colxx>
            <Colxx sm={4}>
              <FormGroup>
                <Label for="priority">Priority</Label>
                <Input className='input_sty'
                  type="number"
                  key={`priority_${index}`}
                  name="priority"
                  id="priority"
                  defaultValue={domain.priority}
                  onChange={(e) => handleInputChange(index, e)}
                />
              </FormGroup>
            </Colxx>
            <Colxx sm={4} className="mb-3">
              <Label>Remove</Label>
              <div>
                <Button
                  onClick={() => handleRemoveFields(index)}
                  color="secondary"
                  size="xs"
                  outline
                  style={{ margin: '6px' }}
                >
                  -
                </Button>
              </div>
            </Colxx>
          </Fragment>
        ))}
      </Row>
      <Button
        onClick={handleAddFields}
        color="primary"
        size="xs"
        outline
        style={{ margin: '6px' }}
      >
        + Add Domain
      </Button>
      {isEditing && (
        <Button
          color="secondary"
          outline
          style={{ float: 'right' }}
          onClick={handleSubmit}
        >
          Save Domains
        </Button>
      )}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}
